import { render, staticRenderFns } from "./RestoreForm.vue?vue&type=template&id=4444b128&scoped=true&lang=pug&"
import script from "./RestoreForm.vue?vue&type=script&lang=ts&"
export * from "./RestoreForm.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreForm.vue?vue&type=style&index=0&id=4444b128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4444b128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardText})
